import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

export default function Layout() {
  return (
    <div className="flex-1 bg-gray-50 flex flex-col">
      {/* Header - 항상 상단 고정 */}
      <Header />

      {/* Main Content - 고정 헤더 높이(h-16 = 64px)만큼 상단 여백, flex-1로 나머지 공간 채움 */}
      <main className="pt-16 flex-1">
        <div className="max-w-[1440px] mx-auto">
          <Outlet />
        </div>
      </main>

      {/* Footer - mt-auto로 항상 하단에 위치 */}
      <Footer />
    </div>
  );
}
